import { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button } from "react-bootstrap";
import Select from "react-select";
import Loader from "../Common/Loader";

import {
  createFrequencyAction,
  updateFrequencyAction,
} from "../../../store/actions/FrequencyAction";

const AddFrequency = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { item } = location.state || {};
  const isEditMode = !!item;

  const [text, setText] = useState("");
  const [status, setStatus] = useState(1);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const statusOptions = [
    { value: 1, label: "Active" },
    { value: 0, label: "Inactive" },
  ];

  // ✅ PREFILL ON EDIT
  useEffect(() => {
    if (isEditMode && item) {
      setText(item.frequency_text || "");
      setStatus(item.frequency_status === "Active" ? 1 : 0);
    }
  }, [item, isEditMode]);

  // ✅ VALIDATION
  const validateForm = () => {
    const newErrors = {};
    if (!text.trim()) newErrors.text = "Frequency is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const clearFieldError = (field) => {
    setErrors((prev) => {
      if (!prev[field]) return prev;
      const { [field]: _removed, ...rest } = prev;
      return rest;
    });
  };

  const handleFieldChange = (field, value) => {
    if (field === "text") {
      setText(value);
    } else if (field === "status") {
      setStatus(value);
    }
    clearFieldError(field);
  };

  // ✅ SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const payload = {
      frequency_text: text,
      frequency_status: status === 1 ? "Active" : "Inactive",
    };

    try {
      setLoading(true);

      if (isEditMode) {
        payload.frequency_id = item.frequency_id;
        await dispatch(updateFrequencyAction(payload, item.frequency_id, navigate));
      } else {
        await dispatch(createFrequencyAction(payload, navigate));
      }

    } catch (error) {
      console.error("Save failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-xl-12">

        <div className="d-flex justify-content-end mb-3">
          <Link to="/frequency">
            <Button variant="primary">Back</Button>
          </Link>
        </div>

        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>

              {/* FREQUENCY */}
              <div className="mb-3">
                <label className="form-label">
                  Frequency <span className="text-danger">*</span>
                </label>

                <textarea
                  className="form-control"
                  rows="3"
                  value={text}
                  style={{ padding: "0.375rem 0.75rem", paddingTop: "0.6rem" }}
                  onChange={(e) => handleFieldChange("text", e.target.value)}
                />

                {errors.text && (
                  <div className="text-danger">{errors.text}</div>
                )}
              </div>

              {/* STATUS */}
              <div className="mb-3">
                <label className="form-label">
                  Status <span className="text-danger"></span>
                </label>

                <Select
                  options={statusOptions}
                  value={statusOptions.find(
                    (opt) => opt.value === status
                  )}
                  onChange={(selectedOption) =>
                    setStatus(selectedOption ? selectedOption.value : "")
                  }
                  placeholder="Select Status"
                  isClearable
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      minHeight: "50px",
                      height: "50px",
                      borderColor: errors.status
                        ? "#dc3545"
                        : provided.borderColor,
                      boxShadow: errors.status
                        ? "0 0 0 0.2rem rgba(220,53,69,.25)"
                        : provided.boxShadow,
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      lineHeight: "50px",
                    }),
                    dropdownIndicator: (provided) => ({
                      ...provided,
                      padding: "4px",
                    }),
                    indicatorSeparator: () => ({
                      display: "none",
                    }),
                  }}
                />

                {errors.status && (
                  <small className="text-danger">{errors.status}</small>
                )}
              </div>


              {/* BUTTON */}
              <button className="btn btn-primary" disabled={loading}>
                {loading ? (
                  <>
                    <Loader size="sm" /> Saving...
                  </>
                ) : isEditMode ? (
                  "Update Frequency"
                ) : (
                  "Add Frequency"
                )}
              </button>

            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddFrequency;
